import React from 'react'
import { Link } from 'react-router-dom'
import CardUI from '../../../widgets/layout/CardUI'
import './PaymentDateSchedule.css'

const PaymentDateScheduleUI = ({ totalPaid, priorPaidLoanRepaymentList, priorPrepaidLoanRepaymentList }) =>
  <CardUI title='Overdues Paid' className='c_table_paid'>
    <table>
      <thead>
        <tr>
          <th />
          <th>Account/Loan</th>
          <th>Scheduled Date</th>
          <th>EMI</th>
          <th>Dsra Dip Interest</th>
          <th>Penal Charge</th>
        </tr>
      </thead>
      <tbody>
        {
          priorPaidLoanRepaymentList && priorPaidLoanRepaymentList.map((repayment, i) =>
            <tr>
              <td>{i + 1}</td>
              <td>{repayment.accountName}<br />
                <Link to={`/su/loans/${repayment.loanId}/repayments`}>
                  {repayment.loanName}
                </Link>
              </td>
              <td>{repayment.scheduledDateF1}</td>
              <td className='g_text_right'>
                <span className='g_flex_v'>
                  {repayment.emiPaidAmountF5}
                  <span className='g_small g_muted'>{repayment.emiPaidAmountDateF1}</span>
                </span>
              </td>
              <td className='g_text_right'>
                <span className='g_flex_v'>
                  {repayment.dsraDipInterestPaidAmountF5}
                  <span className='g_small g_muted'>{repayment.dsraDipInterestPaidAmountDateF1}</span>
                </span>
              </td>
              <td className='g_text_right'>
                <span className='g_flex_v'>
                  {repayment.defaultInterestPaidAmountF5}
                  <span className='g_small g_muted'>{repayment.defaultInterestPaidAmountDateF1}</span>
                </span>
              </td>
            </tr>
          )
        }
        <tr>
          <td />
          <td><b>Subtotal</b></td>
          <td />
          <td className='g_text_right'><b>{totalPaid.totalEMIPaidF5}</b></td>
          <td className='g_text_right'><b>{totalPaid.totalDSRADipInterestPaidF5}</b></td>
          <td className='g_text_right'><b>{totalPaid.totalDefaultInterestPaidF5}</b></td>
        </tr>
      </tbody>
    </table>

    <div className='g_m_top_50'>
      <span className='g_m_left_50'><b>Total: {totalPaid.totalPriorPaidF5}</b></span>
    </div>

    {
      totalPaid.totalEMIPrepaid !== 0 &&
      <table className='g_m_top_100'>
        <thead>
          <tr>
            <th />
            <th>Account/Loan</th>
            <th>Scheduled Date</th>
            <th>Prior Prepaid</th>
          </tr>
        </thead>
        <tbody>
          {
            priorPrepaidLoanRepaymentList.map((repayment, i) =>
              <tr>
                <td>{i + 1}</td>
                <td>{repayment.accountName}<br />
                  <Link to={`/su/loans/${repayment.loanId}/repayments`}>
                    {repayment.loanName}
                  </Link>
                </td>
                <td>{repayment.scheduledDateF1}</td>
                <td className='g_text_right'>
                  <span className='g_flex_v'>
                    {repayment.emiPaidAmountF5}
                    <span className='g_small g_muted'>{repayment.emiPaidAmountDateF1}</span>
                  </span>
                </td>
              </tr>
            )
          }
          <tr>
            <td />
            <td><b>Total</b></td>
            <td />
            <td className='g_text_right'><b>{totalPaid.totalEMIPrepaidF5}</b></td>
          </tr>
        </tbody>
      </table>
    }

  </CardUI>

export default PaymentDateScheduleUI
